import { render, staticRenderFns } from "./remotely.vue?vue&type=template&id=0044d21a&scoped=true&"
import script from "./remotely.vue?vue&type=script&lang=js&"
export * from "./remotely.vue?vue&type=script&lang=js&"
import style0 from "./remotely.vue?vue&type=style&index=0&id=0044d21a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0044d21a",
  null
  
)

export default component.exports